import * as React from "react";

function SvgJackDb(props, ref) {
  return (
    <svg
      id="JackDB_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 265 297.2"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".JackDB_svg__st0{fill:#679ed6}.JackDB_svg__st1{fill:#5794d2}.JackDB_svg__st2{fill:#2c76c2}.JackDB_svg__st3{fill:#286cb1}"
        }
      </style>
      <path
        className="JackDB_svg__st0"
        d="M128.9.2c2.7-.7 4.8.9 7 2.1 38.9 22.5 77.9 44.9 116.8 67.4 5 2.9 5.3 4.5.7 7.1-19 11-38.1 21.9-57.2 32.9-.6.3-1.2.4-1.9.6-1.8 0-3.1-1-4.6-1.8-20.3-11.8-40.6-23.5-60.8-35.2V.2z"
      />
      <path
        className="JackDB_svg__st1"
        d="M128.9.2v74c-1.4.6-2.8 1-4.1 1.7-13.5 7.8-27 15.5-40.4 23.5-6.5 3.9-13.6 6.8-19.4 11.9C44.7 99.6 24.5 88.1 4.4 76.4c-3.9-2.3-3.6-3.8 1-6.6 23-13.3 46-26.6 69.1-39.9 16.3-9.4 32.6-18.7 48.8-28.1 1.7-1 3.4-2.1 5.6-1.6z"
      />
      <path
        className="JackDB_svg__st0"
        d="M258.6 222.1c-.9 2.9-3.6 3.7-5.9 5-38.7 22.4-77.4 44.7-116.1 67-2.4 1.4-4.6 3.4-7.8 2.9v-36.9c11.4-4.8 21.6-11.8 32.3-17.8 20.6-11.7 41-23.6 61.4-35.4 1.3-.7 2.7-1.2 4-1.8 4.4 2.4 8.6 5 13.1 7.2 6.5 3.2 11.9 8.2 19 9.8z"
      />
      <path
        className="JackDB_svg__st1"
        d="M128.8 260.2v36.9c-2.2.3-3.8-1-5.5-2-38.9-22.4-77.8-44.8-116.6-67.2-2.1-1.2-4.6-2.1-6-4.3 9.6-7.3 20.5-12.4 30.9-18.3 12.3 5.9 23.7 13.3 35.6 20.1 18.2 10.4 36.3 20.9 54.5 31.4 2.3 1.2 4.8 2.3 7.1 3.4z"
      />
      <path
        className="JackDB_svg__st2"
        d="M128.8 74.2v-.9c20.3 11.7 40.6 23.5 60.8 35.2 1.4.8 2.8 1.8 4.6 1.8-5.5 4.5-12.1 7.5-18.2 11-13.4 7.9-26.9 15.6-40.4 23.3-2.1 1.2-4.1 2.9-6.8 2.5V74.2zM161.2 168.1c5.7-4.6 12.4-7.7 18.7-11.3 15.8-9.1 31.7-18.1 47.6-27.1 2.6 2.7 6.1 3.9 9.2 5.7 7.1 4.1 13.9 8.8 21.6 11.9-.1 2-1.7 2.8-3.1 3.6-20 11.5-39.9 23-59.9 34.5-.7.4-1.5.6-2.3.8-2.9-3.4-7-4.9-10.7-7-7.1-3.8-13.4-8.9-21.1-11.1z"
      />
      <path
        className="JackDB_svg__st3"
        d="M31.2 129.8C49.8 140.4 68.4 151 87 161.7c3 1.7 5.9 3.6 8.9 5.4-2.8 3-6.6 4.5-10.1 6.3-7.4 4-14.2 9.3-22.3 12-20.3-11.6-40.6-23.3-60.8-35-1.2-.7-2.8-1.4-2.7-3.2 11-4.7 20.8-11.6 31.2-17.4zM128.8 74.2v73c-1.4.3-2.6-.4-3.8-1-20.1-11.6-40.2-23.3-60.2-34.9 5.8-5.1 12.9-8 19.4-11.9 13.4-7.9 26.9-15.7 40.4-23.5 1.4-.8 2.9-1.2 4.2-1.7z"
      />
      <path
        className="JackDB_svg__st0"
        d="M161.2 168.1c7.8 2.2 14 7.4 20.9 11.1 3.7 2 7.8 3.6 10.7 7-7.8 5.7-16.5 9.9-24.7 14.8-10.2 6-20.4 11.9-30.7 17.7-2.7 1.5-5.1 3.8-8.6 3.5v-36.9c9.7-3.9 18.2-10.1 27.4-15 1.7-.9 3-2.2 5-2.2z"
      />
      <path
        className="JackDB_svg__st1"
        d="M128.8 185.2v36.9c-1.4.3-2.6-.4-3.8-1l-61.5-35.7c8.1-2.7 14.8-8 22.3-12 3.5-1.8 7.3-3.3 10.1-6.3 8.2 4.6 16.3 9.3 24.5 13.9 2.8 1.5 5.7 2.8 8.4 4.2z"
      />
      <path
        className="JackDB_svg__st3"
        d="M31.7 205.2c-10.4 5.9-21.3 11-30.9 18.3-1.6-1.1-1.5-3-1.5-4.5-.1-9.3-.1-18.6-.1-27.9 0-2.7.9-4.6 3.9-2.8 9.5 5.6 19.5 10.6 28.6 16.9z"
      />
      <path
        className="JackDB_svg__st1"
        d="M31.2 129.8C20.8 135.6 11 142.5 0 147.3c-1.9-7.8-.6-15.8-.8-23.7-.1-3.5-1.9-8.5 1.2-10.3 3.3-1.8 6.7 2.4 9.9 4.2 7.1 3.9 14 8.2 20.9 12.3z"
      />
      <path
        className="JackDB_svg__st2"
        d="M258.6 222.1c-7.1-1.6-12.5-6.6-18.9-9.7-4.5-2.2-8.7-4.8-13.1-7.2 9-6.3 18.8-11.1 28.2-16.7 2.4-1.5 4.1-1 4.1 2.3l-.3 31.3z"
      />
      <path
        className="JackDB_svg__st0"
        d="M258.2 147.2c-7.7-3-14.5-7.8-21.6-11.9-3.1-1.8-6.6-3-9.2-5.7 9.2-5.4 18.3-10.8 27.5-16.2 1.8-1 4-1.4 3.9 1.5-.2 10.8 1 21.6-.6 32.3z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgJackDb);
